import { render, staticRenderFns } from "./micro-page-data.vue?vue&type=template&id=c928cc54&scoped=true&"
import script from "./micro-page-data.vue?vue&type=script&lang=js&"
export * from "./micro-page-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c928cc54",
  null
  
)

export default component.exports